const API_URL = process.env.REACT_APP_API_URL + "extras/";

export const GetAllExtraObjectApi = async () => {
  try {
    const response = await fetch(API_URL);

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    const data = await response.json();

    return {
      data: data, 
      status: response.status
    };
  } catch (error) {
    console.error("[GetAllExtraObjectApi] Error fetching extras:", error);
    return {
      data: null,
      status: error.response?.status || 500  
    };
  }
};

export const AddExtraObjectApi = async (formData) => {
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      body: formData, 
      headers: {
        Accept: "application/json",
      },
      
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to create extra object');
    }

    console.log("[AddExtraObjectApi] Successful response:", data);
    return {
      data,
      status: response.status,
    };
  } catch (error) {
    console.error("[AddExtraObjectApi] Error:", error);
    return {
      data: { message: error.message },
      status: error.response?.status || 500,
    };
  }
};  

export const deleteExtraObjects = async (id) => {
  try {
    const response = await fetch(API_URL + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      
      }
    });

    return {
      status: response.status
    };
  } catch (error) {
    console.error("[deletePackeges] Error deleting package:", error);
    return {
      status: 500
    };
  }
};

export const GetAllExtraObjectsApi = async (id) => {
  let data = null
  let response = await fetch(API_URL+ id , {
    method: 'GET',
  })
  if(response.status === 200){
    data= await response.json()
  }

  return {
    data: data,
    status: response.status
  }
}
export const UpdateExtraobjects = async (id, formdata) => {
  let data=null
  const response = await fetch(API_URL + id, {
    method: "PUT",
    body: formdata,
  });
  if(response.ok){
    data = await response.json()
  }

  return {
    data: data,
    status: response.status
  }
}